import { find, includes } from 'lodash'
import generatedAuth from 'app/.generated/auth'
import Vue from 'vue'
import store from '../store'

const auth = {
  /**
   * bcrypt lib
   * @type {Object}
   */
  bcrypt: require('bcryptjs'),

  sessionStorageKey: 'routes',

  /**
   * Check route conditions against authentication rules
   * @return {Boolean}
   */
  checkRoute: to => {
    // Allow for development environment
    if (process.env.NODE_ENV === 'development') return true

    // Allow 'login' route
    if (to.name === 'login') return true

    // Try to match the 'to' path to an auth def
    const match = find(generatedAuth, function (def) {
      return to.path.match(def.regexp)
    })

    // Allow if no matching auth pattern is found
    if (!match) return true

    // Allow if a matching auth pattern is found, but is set to 'bypass'
    if (match.bypass) return true

    // Allow if user is authorized to access this route
    if (auth.isUserAllowedToAccessRoute(match.routeHash)) return true

    // Authenticate
    auth.authenticate(to.path, match.routeHash, match.passHash)

    // Disallow
    return false
  },

  /**
   * Check for requested route in user's allowed routes
   * @param {String} route The route pattern
   */
  isUserAllowedToAccessRoute: route => {
    const allowedRoutes = window.sessionStorage.getItem(auth.sessionStorageKey)
    if (!allowedRoutes) return false
    return includes(JSON.parse(allowedRoutes), route)
  },

  /**
   * Grant user access to a route
   */
  grantUserAccessToRoute: route => {
    const allowedRoutes = JSON.parse(window.sessionStorage.getItem(auth.sessionStorageKey)) || []
    allowedRoutes.push(route)
    window.sessionStorage.setItem(auth.sessionStorageKey, JSON.stringify(allowedRoutes))
  },

  /**
   * Verify password
   * @param {String} password
   * @param {String} hash
   */
  verifyPassword: (password, hash) => {
    return auth.bcrypt.compareSync(password, hash)
  },

  /**
   * Set details for login form
   * @param  {String} toRoute
   * @param  {String} routeHash
   * @param  {String} passHash
   */
  authenticate: (toRoute, routeHash, passHash) => {
    Vue.nextTick(() => {
      store.dispatch('authenticate', {
        toRoute,
        routeHash,
        passHash
      })
    })
  },

  /**
   * Clear details for login
   */
  clearAuthenticate: () => {
    store.dispatch('authenticate', false)
  }
}

export default auth



// WEBPACK FOOTER //
// ./app/src/router/auth.js